import wx from 'weixin-js-sdk'
import axios from 'axios'

// iOS微信浏览器在验证微信jssdk签名时,需要的URL是第一次进入该应用时的URL, 并不是当前页面的URL
var u = navigator.userAgent
// var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

if (isiOS) {
  window.SET_WX_JS_URL = window.location.href
}

const wxConfig = {}

// 线上微信公众号
const baseUrl = process.env.VUE_APP_APIURL
wxConfig.config = function() {
  var params = { url: location.href }
  // if (isiOS) {
  //   params['url'] = window.SET_WX_JS_URL
  // }
  var apiUrl = baseUrl + 'admin/wx/jssdk/config'
  axios
    .get(apiUrl, { params: params })
    .then(response => {
      console.log()
      if (response.data.status === -1) {
        console.log()
      } else {
        var config = response.data.data
        config['jsApiList'] = ['scanQRCode']
        config['appId'] = config.appid
        config['nonceStr'] = config.noncestr
        wx.config(response.data.data)
      }
    })
    .catch(error => {
      console.log(error)
    })
}

wxConfig.asyncConfig = function(path) {
  return new Promise(function(resolve, reject) {
    var params = { url: location.origin + path }
    var apiUrl = baseUrl + 'admin/wx/jssdk/config'
    console.log(params)
    axios
      .get(apiUrl, { params: params })
      .then(response => {
        var config = response.data.data
        config['jsApiList'] = ['scanQRCode']
        config['appId'] = config.appid
        config['nonceStr'] = config.noncestr
        wx.config(response.data.data)
        wx.error(function(res) {
          reject(new Error(res.errMsg))
        })
        // wx.ready(resolve)
        resolve()
      })
      .catch(error => {
        console.log(error)
        reject(error)
      })
  })
}

// 测试微信公众号
// wxConfig.config = function() {
//   console.log('hello ')
//   var url = 'https://yuwechat.herokuapp.com/api/config?url=' + location.href
//   axios
//     .get(url)
//     .then(response => {
//       console.log(response)
//       wx.config(response.data)
//     })
//     .catch(error => {
//       console.log(error)
//     })
// }

// wxConfig.config()

wxConfig.scanQRCode = function() {
  return new Promise((resolve, reject) => {
    wx.ready(function() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          var resultArr = result.split(',')
          if (resultArr.length > 1) {
            resolve(resultArr[1])
          } else {
            resolve(resultArr[0])
          }
        }
      })
      wx.error(error => {
        var str = JSON.stringify(error)
        console.log('config信息验证失败:' + str)
        wxConfig.config()
        reject('config信息验证失败')
      })
    })
  })
}

export default wxConfig
